import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { MatAutocompleteSelectedEvent, MatInput } from "@angular/material";
import { Observable, of } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from "rxjs/operators";

import { PerspectiveService } from "./perspective.service";
import { SnackBarService } from "../core/snack-bar.service";
import { IntroducerSearchService } from "./introducer-search.service";
import { ThemeService } from "../core/theme.service";

import { Introducer } from "./introducer.model";

@Component({
    template: require('./perspective.component.html'),
    //styles: [require('./perspective.component.css')],
    //providers: [PerspectiveService]
})
export class PerspectiveComponent implements AfterViewInit {
    @ViewChild(MatInput) searchInput: MatInput;

    filteredIntroducers$: Observable<Introducer[]>;
    loading: boolean;
    searchFC: FormControl;

    constructor(
        private perspectiveService: PerspectiveService,
        private introducerSearchService: IntroducerSearchService,
        private router: Router,
        private snackBarService: SnackBarService,
        private themeService: ThemeService) {

        this.searchFC = new FormControl();
        this.filteredIntroducers$ = this.searchFC.valueChanges
            .pipe(
                debounceTime(300),
                distinctUntilChanged(),
                switchMap(term => {
                    this.loading = true;
                    return term
                        ? this.introducerSearchService.search(term)
                        : of<Introducer[]>([])
                }),
                catchError(error => {
                    // TODO: add real error handling
                    console.log(error);
                    return of<Introducer[]>([]);
                }),
                tap(() => { this.loading = false; })
            );
    }

    ngAfterViewInit() {
        // probably shouldnt need this setTimeout?
        // https://github.com/angular/material2/issues/1474#issuecomment-293683513
        setTimeout(() => {
            this.searchInput.focus();
        });
    }

    setPerspective(e: MatAutocompleteSelectedEvent): void {
        this.perspectiveService.activeIntroducer = e.option.value as Introducer;

        this.themeService.getTheme()
            .catch(err => this.snackBarService.openSnackBar("Error retrieving theme settings."));

        this.router.navigate(["/enquiries/new"]);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/perspective/perspective.component.ts